/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_IncludedInputs */



/**
* | output |
* | --- |
* | "Included" |
*
* @param {Signup_Compare_IncludedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_included = /** @type {((inputs?: Signup_Compare_IncludedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_IncludedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Included")
	if (locale === "de") return /** @type {LocalizedString} */ ("Included")
	if (locale === "it") return /** @type {LocalizedString} */ ("Included")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Included")
	if (locale === "es") return /** @type {LocalizedString} */ ("Included")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Included")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Included")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Included")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Included")
	return /** @type {LocalizedString} */ ("Included")
});